/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Subtext_Fell_ThroughInputs */



/**
* | output |
* | --- |
* | "This page fell through a Rift and didn't come back." |
*
* @param {Error_Subtext_Fell_ThroughInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_subtext_fell_through = /** @type {((inputs?: Error_Subtext_Fell_ThroughInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Subtext_Fell_ThroughInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Seite ist durch einen Rift gefallen und nicht zurückgekommen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette page est tombée dans une Faille et n'est pas revenue.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这个页面掉进了裂隙，再也没回来。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("這個頁面掉進裂隙，再也沒回來。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이 페이지는 균열로 떨어져 돌아오지 못했습니다.")
	return /** @type {LocalizedString} */ ("This page fell through a Rift and didn't come back.")
});